import { ReportType } from '../interfaces/treatment';

export class MReportType{

    public description: string = null;
    public id: number = null;
    public name: string = null;
    public url: string = null;
    public toolboxId: number = null;

    constructor(type: ReportType){
        this.description = type.descripcion;
        this.id = type.id;
        this.name = type.nombre,
        this.toolboxId = type.toolbox_id;
        this.url = type.ruta
    }

}